import React from 'react';

import { DesignVersionContext } from './designVersionContext.shared';

export function useDesignVersion() {
  const context = React.useContext(DesignVersionContext);

  if (!context) {
    throw new Error('useDesignVersion must be used within DesignVersionProvider');
  }

  return context;
}
